module.exports = __webpack_public_path__ + "img/logo.c7633db4.png";